<app-header></app-header>
<app-menu></app-menu>
<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 row">
  <div
    class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 row"
    style="top: 60px; margin-left: 4vh"
  >
    <div
      class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3 row formulario"
      [formGroup]="fromSelect"
   
    >
     <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
      <h2 class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
        1.Choose the font of your choice
      </h2>

     <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
      <mat-form-field appearance="fill">
        <mat-label>Select an option</mat-label>
        <mat-select formControlName="selec">
          <mat-option *ngFor="let item of pairs;let i = index" [value]="i">{{
            item.body
          }}</mat-option>
        </mat-select>
      </mat-form-field>
     </div>
     </div>
    </div>
    <div class="col-xs-8 col-sm-8 col-md-8 col-lg-8 col-xl-8 col-xxl-8 row">
      <div
        class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6 row"
        style="top: 45px"
      >
      <h2 class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
     
      >2. Select the color of your<br />choice for the section above.</h2
    >
       <div class="col-xs-8 col-sm-8 col-md-8 col-lg-8 col-xl-8 col-xxl-8"> <color-sketch
        id="Primary"
        [color]="coabove"
        style="height: 5px; width: 200px"
        (onChange)="handleChangePrimary($event)"
      ></color-sketch></div>
       
      </div>
      <div
        class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6 row"
        style="top: 45px"
      >
      <h2 class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
     
      >3. Select the color of your<br />choice for the section below.</h2
    >
        <div class="col-xs-8 col-sm-8 col-md-8 col-lg-8 col-xl-8 col-xxl-8">
          <color-sketch
          id="Font"
          style="height: 5px; width: 215px"
          (onChange)="handleChangeFont($event)"
          [color]="cobelow"
        ></color-sketch>
        </div>
      
      </div>
     
    </div>
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12" style="top: 10vh !important;">
      <button
        mat-raised-button
        class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2"
        color="primary"
        (click)="onSaveCustomize()"
        style="left: 72vh !important;"
      >
        Save Customize
      </button>
    </div>
  </div>
</div>
